import { Component, Input, OnInit } from '@angular/core';
import { ModalController, PopoverController } from '@ionic/angular';
import { ColumnSelectComponent } from '../../modal/column-select/column-select.component';
import { IColumn } from '../../interfaces/IColumn';

@Component({
  selector: 'app-column-manage',
  templateUrl: './column-manage.component.html',
  styleUrls: ['./column-manage.component.scss'],
})
export class ColumnManageComponent  implements OnInit {

  @Input() columns:IColumn[] = []

  constructor(
    private _modalController:ModalController,
    private _popoverController:PopoverController
  ) { }

  ngOnInit() {
    
  }

  async openColumnSelect(){
    const columnSelectModal = await this._modalController.create({
      component:ColumnSelectComponent,
      componentProps:{columns:this.columns},
      cssClass:"column-select-modal"
    })
    await columnSelectModal.present()
    const { data } = await columnSelectModal.onDidDismiss();
    if (data) {
      this.columns = data;
      this._popoverController.dismiss(this.columns);
    }
  }

  resetColumn(){
    this._popoverController.dismiss()
  }

}
